<template lang="html">
  <cw-basic-cell @click="$emit('click')">
    <div slot="left-area">
      <icon
        v-if="leftIconProps && !leftIconProps.bulmaIcon && !leftIconProps.badge"
        :name="leftIconProps.name"
        :scale="leftIconProps.scale"
        :label="leftIconProps.label"
        :class="leftIconProps.colorClass"
      ></icon>
      <span
        v-if="leftIconProps && leftIconProps.bulmaIcon"
        class="icon"
        :class="[leftIconProps.colorClass, leftIconProps.scale]"
      >
        <i
          class="fa"
          :class="leftIconProps.name"
          :aria-label="leftIconProps.label"
        ></i>
      </span>
      <span
        v-if="leftIconProps && leftIconProps.badge"
        :class="[leftIconProps.colorClass, leftIconProps.scale]"
      >
        {{ leftIconProps.badge }}
      </span>
    </div>
    <div slot="left-fill-area">
      <div>
        <p class="is-size-5">{{ title }}</p>
        <p class="is-size-5 has-text-grey-light">{{ subtitle }}</p>
      </div>
    </div>
    <div class="is-flex" slot="right-area-1">
      <slot name="right-area"></slot>
      <span
        v-if="showSelectedIndicator"
        class="icon is-medium has-text-primary is-pad-left-1"
      >
        <i class="las la-2x la-check"></i>
      </span>
      <span v-if="showDisclosureIndicator" class="icon">
        <i class="las la-2x la-angle-right"></i>
      </span>
    </div>
    <div slot="right-area-2">
      <div>
        {{ disclosureDetail }}
      </div>
    </div>
  </cw-basic-cell>
</template>

<script>
export default {
  name: 'cw-list-cell',
  props: {
    title: {
      type: String,
      required: false,
      default: '',
    },
    subtitle: {
      type: String,
      required: false,
      default: '',
    },
    disclosureDetail: {
      type: String,
      required: false,
      default: '',
    },
    leftIconProps: {
      type: Object,
      required: false,
    },
    showDisclosureIndicator: {
      type: Boolean,
      required: false,
      default: true,
    },
    showSelectedIndicator: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
};
</script>

<style lang="stylus" scoped></style>
